import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CountdownTimer } from './CountdownTimer';
import { X, Check, ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
export function FinalCTA() {
  const comparison = [{
    sin: 'Noches de culpa sin saber qué hiciste mal',
    con: 'Claridad sobre su diseño desde el día 1'
  }, {
    sin: 'Berrinches que se repiten sin solución',
    con: 'Diccionario de 100 conductas con respuesta exacta'
  }, {
    sin: 'Técnicas genéricas que no funcionan con él',
    con: 'Herramientas diseñadas para su elemento único'
  }, {
    sin: 'Apagar incendios sin plan ni dirección',
    con: 'Sistema completo de vínculo y conexión anual'
  }, {
    sin: 'Sentirte sola en la crianza',
    con: 'Comunidad de mamás que ya recorrieron este camino'
  }];
  return <SectionWrapper className="text-center" data-id="element-55">
      <h2 className="text-5xl md:text-7xl font-black text-burgundy mb-6" data-id="element-56">
        🌟 CÓDIGO HIJO
      </h2>

      <div className="max-w-3xl mx-auto mb-12" data-id="element-57">
        <p className="text-2xl md:text-3xl font-serif text-text-main mb-8 leading-relaxed" data-id="element-58">
          El próximo domingo podés seguir buscando en Google.
          <br data-id="element-59" />
          <strong className="text-burgundy" data-id="element-60">
            O podés tener el manual de tu hijo desde hoy.
          </strong>
        </p>

        <p className="text-xl font-bold text-dusty-rose uppercase tracking-widest mb-8" data-id="element-61">
          ¿Cuánto cuesta NO tenerlo?
        </p>
      </div>

      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-sm border border-dusty-rose/20 overflow-hidden mb-16" data-id="element-62">
        <div className="grid grid-cols-2 bg-card-bg border-b border-dusty-rose/20" data-id="element-63">
          <div className="p-4 md:p-6 font-bold text-text-main/60 text-center flex flex-col items-center justify-center" data-id="element-64">
            <span data-id="element-65">SIN CÓDIGO HIJO</span>
            <X className="text-red-400 mt-1" size={20} data-id="element-66" />
          </div>
          <div className="p-4 md:p-6 font-black text-burgundy text-center border-l border-dusty-rose/10 bg-gold/5 flex flex-col items-center justify-center" data-id="element-67">
            <span data-id="element-68">CON CÓDIGO HIJO</span>
            <Check className="text-green-600 mt-1" size={24} data-id="element-69" />
          </div>
        </div>

        {comparison.map((row, i) => <div key={i} className={`grid grid-cols-2 border-b border-dusty-rose/10 last:border-0 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`} data-id="element-70">
            <div className="p-4 md:p-6 text-text-main/60 text-center text-sm md:text-base flex items-center justify-center" data-id="element-71">
              {row.sin}
            </div>
            <div className="p-4 md:p-6 font-bold text-burgundy text-center border-l border-dusty-rose/10 bg-gold/5 text-sm md:text-base flex items-center justify-center" data-id="element-72">
              {row.con}
            </div>
          </div>)}
      </div>

      <div className="mb-16" data-id="element-73">
        <CountdownTimer data-id="element-74" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12" data-id="element-75">
        {/* Card 1 - Premium (primero) */}
        <div className="bg-card-bg rounded-2xl p-6 border-2 border-gold shadow-md flex flex-col justify-between relative" data-id="element-76">
          <div className="absolute -top-3 right-4 bg-gold text-text-main px-3 py-1 rounded-full text-xs font-black tracking-wider shadow-sm" data-id="element-77">
            ⭐ PRO
          </div>
          <div data-id="element-78">
            <h3 className="text-xl font-black text-burgundy mb-1" data-id="element-79">
              🏆 CÓDIGO HIJO + CRIANZA PRO ⭐
            </h3>
            <p className="text-sm text-text-main/70 mb-4" data-id="element-80">
              6 Tomos + 3 Bonus + Crianza Pro
            </p>
            <p className="text-4xl font-black text-burgundy mb-6" data-id="element-81">$13.97 USD</p>
          </div>
          <a href="https://pay.hotmart.com/H105289774B?checkoutMode=10" className="block w-full bg-burgundy text-white font-bold py-3 rounded-xl hover:bg-burgundy/90 shadow-md hover:-translate-y-0.5 transition-all text-center" data-id="element-82">
            → QUIERO EL PACK COMPLETO
          </a>
        </div>

        {/* Card 2 - Standard (segundo) */}
        <div className="bg-white rounded-2xl p-6 border border-dusty-rose/30 shadow-sm flex flex-col justify-between" data-id="element-83">
          <div data-id="element-84">
            <h3 className="text-xl font-black text-text-main mb-1" data-id="element-85">
              📘 CÓDIGO HIJO COMPLETO
            </h3>
            <p className="text-sm text-text-main/70 mb-4" data-id="element-86">6 Tomos + 3 Bonus</p>
            <p className="text-4xl font-black text-burgundy mb-6" data-id="element-87">$9.97 USD</p>
          </div>
          <a href="https://pay.hotmart.com/S104936734A" className="block w-full bg-white text-burgundy border-2 border-burgundy font-bold py-3 rounded-xl hover:bg-burgundy/5 transition-colors text-center" data-id="element-88">
            → QUIERO MI CÓDIGO HIJO
          </a>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-text-main/70 font-medium" data-id="element-89">
        <span className="flex items-center gap-1" data-id="element-90">
          <Lock size={16} className="text-gray-600" data-id="element-91" /> Pago 100% seguro
        </span>
        <span className="flex items-center gap-1" data-id="element-92">
          <Zap size={16} className="text-yellow-500" data-id="element-93" /> Acceso en 5 minutos
        </span>
        <span className="flex items-center gap-1" data-id="element-94">
          <ShieldCheck size={16} className="text-green-600" data-id="element-95" /> Garantía 7 días
          sin preguntas
        </span>
        <span className="flex items-center gap-1" data-id="element-96">
          <CreditCard size={16} className="text-blue-600" data-id="element-97" /> Paga en tu moneda
          local
        </span>
      </div>
    </SectionWrapper>;
}